module.exports = __webpack_public_path__ + "img/banner-survey.c797b1de.png";